import { useEffect, useRef, useState } from 'react'

import useStoreLanguages from '../useStoreLanguages/useStoreLanguages'
import { commitLayoutErrors, countLayoutErrors, getLayoutErrors } from './helpers'

const useBlockErrors = ({ layout, blockSettings, getBlockVisibility, openBlockId }) => {
  const languages = useStoreLanguages()
  const [openBlockErrors, setOpenBlockErrors] = useState(null)

  const layoutErrors = layout ? getLayoutErrors({ layout, blockSettings, getBlockVisibility, languages }) : {}
  const layoutErrorsRef = useRef(layoutErrors)

  layoutErrorsRef.current = layoutErrors

  useEffect(() => {
    setOpenBlockErrors(openBlockId ? layoutErrorsRef.current[openBlockId] : null)
  }, [openBlockId])

  const committedLayoutErrors = commitLayoutErrors(layoutErrors, openBlockId, openBlockErrors)

  return {
    layoutErrors,
    hasErrors: Object.keys(layoutErrors).length > 0,
    committedLayoutErrors,
    committedErrorCount: countLayoutErrors(committedLayoutErrors),
  }
}

export default useBlockErrors
